import {KeyConstant} from "../constant/keyConstant";
import moment from "moment";
import React from "react";

const format = "DD/MM/YYYY"
const formatMonth = "MMMM, YYYY"
const formatCompareDMY = "YYYYMMDD"
const formatCompareMY = "YYYYMM"
const formatCompareY = "YYYY"
const mapAboutDays = (startDate , endDate) =>{

    if (moment(startDate).format(formatCompareDMY) === moment(endDate).format(formatCompareDMY)){
        return <>
            <span> {moment(startDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareMY) === moment(endDate).format(formatCompareMY)){
        return <>
            <span> {moment(startDate).format("DD")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareY) === moment(endDate).format(formatCompareY)){
        return <>
            <span> {moment(startDate).format("DD/MM")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    return <>
        <span> {moment(startDate).format("DD/MM/YYYY")} </span> -
        <span> {moment(endDate).format("DD/MM/YYYY")} </span>
    </>
}
export const mapTitleDate = (type , startDate , endDate)=>{

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return  moment(startDate).format(format)
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return  moment(startDate).format(formatMonth).charAt(0).toUpperCase() +
                moment(startDate).format(formatMonth).slice(1)
        default :
            return mapAboutDays(startDate, endDate)
    }
}
